import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface HomeLocationSearchFocus {
  id: number;
  latitude: number;
  longitude: number;
  label: string;
  radiusKm: number;
}

export type HomeLocationSearchRequest = Omit<HomeLocationSearchFocus, 'id'>;

@Injectable({
  providedIn: 'root',
})
export class HomeLocationSearchService {
  private nextId = 0;
  private readonly focusSubject = new Subject<HomeLocationSearchFocus>();

  readonly focus$ = this.focusSubject.asObservable();

  focusLocation(request: HomeLocationSearchRequest): void {
    this.focusSubject.next({
      ...request,
      id: ++this.nextId,
    });
  }
}
